(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanlara-bruna-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.van-tabs-products').forEach((section) => {
      const buttons = section.querySelectorAll('[data-van-tabs-button]');
      const panels = section.querySelectorAll('[data-van-tabs-panel]');
      const viewLinks = section.querySelectorAll('[data-van-tabs-view], [data-van-tabs-view-mobile]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const id = button.dataset.vanTabsButton;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const active = panel.dataset.vanTabsPanel === id;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
            if (active) {
              viewLinks.forEach((link) => {
                link.href = panel.dataset.vanTabsUrl || link.href;
              });
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanlara-bruna-home-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-van-banner]').forEach((section) => {
        if (section.dataset.vanBannerReady === 'true') return;
        section.dataset.vanBannerReady = 'true';

        const slides = Array.from(section.querySelectorAll('[data-van-banner-slide]'));
        const dots = Array.from(section.querySelectorAll('[data-van-banner-dot]'));
        const interval = Number(section.style.getPropertyValue('--van-banner-interval').replace('ms', '')) || 5000;
        let index = 0;
        let timer;

        const show = (nextIndex) => {
          if (!slides.length) return;
          index = nextIndex;
          slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
          dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
        };

        const start = () => {
          window.clearInterval(timer);
          if (slides.length > 1) {
            timer = window.setInterval(() => show((index + 1) % slides.length), interval);
          }
        };

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            show(Number(dot.dataset.vanBannerDot) || 0);
            start();
          });
        });

        start();
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanlara-community-inspiration"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      const sections = root.querySelectorAll('.van-community');

      sections.forEach((section) => {
      if (section.dataset.vanCommunityReady === 'true') return;
      section.dataset.vanCommunityReady = 'true';

      const rail = section.querySelector('[data-van-community-rail]');
      if (!rail) return;

      const speed = Number(section.style.getPropertyValue('--van-community-speed')) || 34;
      const autoplay = section.dataset.vanCommunityAutoplay === 'true';
      const looped = rail.dataset.vanCommunityLoop === 'true';
      const scrollAutoplay = autoplay && looped;
      let paused = false;
      let resumeTimer;
      let lastTime;
      let resetPoint = 0;
      let isDragging = false;
      let dragMoved = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let activeButton;
      let touchStartX = 0;
      let touchStartY = 0;

      const fillLoop = () => {
        if (!autoplay || !looped || rail.dataset.vanCommunityFilled === 'true') return;
        const originals = Array.from(rail.querySelectorAll('.van-community__tile:not([aria-hidden="true"])'));
        let guard = 0;

        while (rail.scrollWidth < rail.clientWidth * 2.2 && guard < 4) {
          originals.forEach((tile) => {
            const clone = tile.cloneNode(true);
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('aria-hidden', 'true');
            rail.appendChild(clone);
          });
          guard += 1;
        }

        rail.dataset.vanCommunityFilled = 'true';
      };

      const measure = () => {
        const tiles = rail.querySelectorAll('.van-community__tile');
        const duplicateStart = rail.querySelector('.van-community__tile[aria-hidden="true"]');
        resetPoint = 0;
        if (autoplay && looped && tiles.length > 1) {
          resetPoint = duplicateStart ? duplicateStart.offsetLeft : rail.scrollWidth / 2;
          if (!resetPoint || resetPoint <= rail.clientWidth) resetPoint = rail.scrollWidth / 2;
        }
      };

      const pause = () => {
        paused = true;
        rail.classList.add('is-paused');
        window.clearTimeout(resumeTimer);
      };

      const resumeSoon = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          paused = false;
          rail.classList.remove('is-paused');
        }, 700);
      };

      const openModal = (button) => {
        const modal = section.querySelector(`[data-van-community-modal="${button.dataset.vanCommunityOpen}"]`);
        if (!modal) return;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      };

      const startDrag = (event) => {
        if (event.pointerType === 'touch') return;
        if (rail.scrollWidth <= rail.clientWidth) return;
        activeButton = event.target.closest('[data-van-community-open]');
        measure();
        pause();
        isDragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartScrollLeft = rail.scrollLeft;
        rail.setPointerCapture?.(event.pointerId);
      };

      const drag = (event) => {
        if (!isDragging) return;
        const deltaX = event.clientX - dragStartX;
        if (Math.abs(deltaX) > 4) dragMoved = true;
        rail.scrollLeft = dragStartScrollLeft - deltaX;
        if (resetPoint > 0 && rail.scrollLeft >= resetPoint) {
          rail.scrollLeft = rail.scrollLeft - resetPoint;
          dragStartScrollLeft = rail.scrollLeft + deltaX;
        }
      };

      const endDrag = (event) => {
        if (!isDragging) return;
        const button = activeButton;
        const wasMoved = dragMoved;
        isDragging = false;
        activeButton = null;
        rail.releasePointerCapture?.(event.pointerId);
        if (!wasMoved && button) openModal(button);
        resumeSoon();
      };

      const tick = (time) => {
        if (!lastTime) lastTime = time;
        const delta = time - lastTime;
        lastTime = time;

        if (scrollAutoplay && !paused && rail.scrollWidth > rail.clientWidth) {
          if (!resetPoint) measure();
          rail.scrollLeft += speed * delta / 1000;
          if (resetPoint > 0 && rail.scrollLeft >= resetPoint) {
            rail.scrollLeft = rail.scrollLeft - resetPoint;
          }
        }

        window.requestAnimationFrame(tick);
      };

      fillLoop();
      measure();
      window.setTimeout(measure, 400);
      if ('ResizeObserver' in window) {
        new ResizeObserver(measure).observe(rail);
      } else {
        window.addEventListener('resize', measure);
      }

      rail.addEventListener('scroll', measure, { passive: true });
      rail.addEventListener('pointerdown', startDrag);
      rail.addEventListener('pointermove', drag);
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('wheel', (event) => {
        if (rail.scrollWidth <= rail.clientWidth) return;
        const delta = event.deltaX || event.deltaY;
        if (!delta) return;
        event.preventDefault();
        measure();
        pause();
        rail.scrollLeft += delta;
        if (resetPoint > 0 && rail.scrollLeft >= resetPoint) {
          rail.scrollLeft = rail.scrollLeft - resetPoint;
        }
        resumeSoon();
      }, { passive: false });
      rail.addEventListener('click', (event) => {
        if (!dragMoved) return;
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);
      rail.addEventListener('touchstart', (event) => {
        const touch = event.touches && event.touches[0];
        if (touch) {
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          dragMoved = false;
        }
        pause();
      }, { passive: true });
      rail.addEventListener('touchmove', (event) => {
        const touch = event.touches && event.touches[0];
        if (!touch) return;
        const deltaX = Math.abs(touch.clientX - touchStartX);
        const deltaY = Math.abs(touch.clientY - touchStartY);
        if (deltaX > 8 && deltaX > deltaY) dragMoved = true;
      }, { passive: true });
      rail.addEventListener('touchend', resumeSoon, { passive: true });
      rail.addEventListener('touchcancel', resumeSoon, { passive: true });
      window.requestAnimationFrame(tick);

      section.querySelectorAll('[data-van-community-open]').forEach((button) => {
        button.addEventListener('click', () => openModal(button));
      });

      section.querySelectorAll('.van-community-modal').forEach((modal) => {
        const close = () => {
          modal.hidden = true;
          document.documentElement.style.overflow = '';
        };

        modal.querySelector('[data-van-community-close]')?.addEventListener('click', close);
        modal.addEventListener('click', (event) => {
          if (event.target === modal) close();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !modal.hidden) close();
        });
      });
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanlara-product-materials-swipe"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.currentScript?.closest('[data-material-slider]') || document.querySelector('[data-material-slider]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const slides = [...root.querySelectorAll('[data-material-slide]')];
  const dots = [...root.querySelectorAll('[data-material-dot]')];
  if (slides.length < 2) return;
  let index = 0;
  let timer;
  const show = (next) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  };
  const restart = () => {
    clearInterval(timer);
    if (root.dataset.autoplay === 'true') timer = setInterval(() => show(index + 1), Number(root.dataset.interval) || 3000);
  };
  const pauseAndResume = () => {
    clearInterval(timer);
    if (root.dataset.autoplay === 'true') setTimeout(restart, 10000);
  };
  root.querySelector('[data-material-prev]')?.addEventListener('click', () => { show(index - 1); pauseAndResume(); });
  root.querySelector('[data-material-next]')?.addEventListener('click', () => { show(index + 1); pauseAndResume(); });
  dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.materialDot)); pauseAndResume(); }));
  let startX = 0;
  root.addEventListener('touchstart', event => { startX = event.changedTouches[0].clientX; clearInterval(timer); }, {passive:true});
  root.addEventListener('touchend', event => {
    const distance = event.changedTouches[0].clientX - startX;
    if (Math.abs(distance) > 35) show(index + (distance < 0 ? 1 : -1));
    pauseAndResume();
  }, {passive:true});
  restart();
})();

  } catch(e) { console.error(e); }
})();
})();
